import { LoanRecord } from '../types/highlights'

export const loan: LoanRecord = {
  loanPurpose: 'Purchase',
  chosenLender: 'UWM',
  currentLoanStatus: 'In Underwriting',
  qmType: 'QM',
  madisonEcd: '8/17/2026',
  rateLockExp: '9/9/2026',
  rateLockDaysLeft: 5,
  loanAmount: 434250,
  rate: 6.0,
  dti: 46.2,
  ltv: 96.5,
  cltv: 96.5,
  fico: 807,
  loanProgram: null,
  subjectPropertyAddress: '12334 test st, Hicksville, NY 11801',
  appraisalStatus: 'Received',
  appraisedValue: 450000,
  closingDate: '9/26/2026',
  loanOfficer: 'Dana Whitfield',
  processor: 'Marcus Ruiz',
  borrower: 'A. Patel',
  occupancy: 'Primary Residence',
  propertyType: 'Single Family',
  reservesMonths: 1.5,
  conditionsOutstanding: 7,
  docsExpiringDays: 12,
  escrowWaived: false,
  cashToClose: 28450,
  monthlyPayment: 3126.42,
  spousalState: true,
  witnessState: true,
  processingType: 'Full-Service',
  channel: 'CORR',
  compensationType: 'YSP',
  closingType: 'In Person',
}
